import React from 'react'
import Division from '../components/division'
import FaqList from '../components/faq'

export default ({ title, faq, button, background }) => (
  <Division title={title} button={button} background={background}>
    <FaqList data={faq} />
  </Division>
)
